import { useContext } from "react";

import { TimeLookbackContext } from "@providers";

// Returns the current time lookback value
// Useful for getting the updated TimeLookbackRange without having to poll cookies
export const useTimeLookbackRange = () => {
  const { tlr, setTlr } = useContext(TimeLookbackContext);
  return { tlr, setTlr };
};
